import mixpanel from 'mixpanel-browser';

mixpanel.init("8c4ccfc99ab341024e427091e6c7215f", {
  debug: true,
});

export default mixpanel;
